

import { IRulesetAction } from '@interfaces/maps/Map.interface';
import { CEntity, CView, IBackground, IEntity, ILayer, ILayerRuleset, IMapLayer, IMapOptions, IStatusIndicator, TElementID, TEntity } from '@ts/ui-models';

export class CMapLayer extends CEntity<IMapLayer> implements IMapLayer {
  viewId: string;
  layerId: string;
  properties: IMapOptions;
  layer: CLayer;
  itemIDs: string[] = [];
  itemIDsWithPosition: string[] = [];
  geometriesIds: string[] = []; //same locationsIds
  itemActions: Record<TElementID, IRulesetAction[]> = {}; //Only one position
  indicators: Record<TElementID, IStatusIndicator[]> = {};
  indeterminate: boolean = false;

  constructor(inter: IMapLayer) {
    super(inter);
    this.viewId = inter.viewId;
    this.layerId = inter.layerId;
    this.properties = inter.properties;
    this.layer = new CLayer(inter.layer);
  }

  get background(): IBackground | null {
    return this.layer.background ?? null;
  }

  getInfoBubbleFromElementID(elementID: string): IRulesetAction {
    return this.itemActions[elementID][0];
  }

  getName(): string {
    return this.layer.name ?? 'Unknown';
  }

  getID(): string {
    return this.layer.getID();
  }

  getVisualizationID(): string {
    return this.layer.getVisualizationID();
  }

  static default(view: CView): CMapLayer {
    return new CMapLayer({
      id: 'customLayer',
      logicalId: 'customLayer',
      viewId: view.getID(),
      layerId: 'customLayer',
      properties: view.properties,
      layer: CLayer.default(),
    });
  }
}

export class CLayer extends CEntity<ILayer> implements ILayer {
  tEntity: TEntity = 'layer';
  name: string;
  aliveStart: string;
  aliveEnd: string | null;
  defaultAttributes: string | null;
  hoverAttributes: string | null;
  iconId: string | null;
  backgroundId: string | null;
  ownerOrganizationId: string;
  icon: string | null;
  background: IBackground | null;
  xLayerRulesets: ILayerRuleset[];

  constructor(inter: ILayer) {
    super(inter);
    this.id = inter.id;
    this.logicalId = inter.logicalId;
    this.name = inter.name;
    this.aliveStart = inter.aliveStart;
    this.aliveEnd = inter.aliveEnd;
    this.defaultAttributes = inter.defaultAttributes;
    this.hoverAttributes = inter.hoverAttributes;
    this.iconId = inter.iconId;
    this.backgroundId = inter.backgroundId;
    this.ownerOrganizationId = inter.ownerOrganizationId;
    this.icon = inter.icon;
    this.background = inter.background;
    this.xLayerRulesets = inter.xLayerRulesets;
  }

  static default(): CLayer {
    return new CLayer({
      id: 'customLayer',
      logicalId: 'customLayer',
      name: 'Search Layer',
      aliveStart: '',
      aliveEnd: null,
      defaultAttributes: null,
      hoverAttributes: null,
      iconId: null,
      backgroundId: null,
      ownerOrganizationId: '',
      icon: null,
      background: null,
      xLayerRulesets: [],
    });
  }
}
